'use client'

import { useState } from 'react'
import Modal from './Modal'
import useReviewModal from '@/app/hooks/useReviewModal'
import apiService from '@/app/services/apiService'
import { Star } from 'lucide-react'
import toast from 'react-hot-toast'

interface ReviewModalProps {
  reservationId: string
}

export default function ReviewModal({ reservationId }: ReviewModalProps) {
  const { isOpen, close } = useReviewModal()
  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    if (rating < 1) {
      toast.error('Por favor, escolha uma nota.')
      return
    }

    setLoading(true)
    try {
      await apiService.postWithToken(`/api/user/submit/${reservationId}/`, {
        rating,
        comment
      })
      toast.success('Avaliação enviada com sucesso!')
      close()
      setRating(0)
      setComment('')
    } catch (err: any) {
      toast.error(err?.response?.data?.error || 'Erro ao enviar avaliação.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
        isOpen={isOpen}
        close={close}
        label="Avaliar Serviço"
        content={
            <div className="space-y-4">
                <div className="flex space-x-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        onClick={() => setRating(star)}
                        className={`text-yellow-500 ${rating >= star ? 'fill-yellow-500' : 'opacity-30'}`}
                    >
                        <Star size={28} />
                    </button>
                    ))}
                </div>

                <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Como você qualifica esse performer? Você recomendaria?"
                    className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                    rows={4}
                />

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                >
                    Enviar Avaliação
                </button>
            </div>
        }
    />
  )
}
